import React from "react";
import ReactMapGL, {Marker, Popup, NavigationControl} from 'react-map-gl'
import 'mapbox-gl/dist/mapbox-gl.css';
import WebMercatorViewport from 'viewport-mercator-project';
import ListingInfo from './listing_info.js'
import ListingPin from './listing_pin.js'
import { shortDollarFormat, trackClick } from '../util/util.js';

const defaults = require('../defaults');


const mapboxToken = 'pk.eyJ1IjoiYWRvYmVsaXMtYWR2IiwiYSI6ImNqcGJtdXQ0eTIydXIzd3Fza2FudDN0d2kifQ.NPIp-5FiKM9yxt57thyDfQ';

const navStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  padding: '10px'
};

const noBottomMobileAdAffs = [
    'nj',
    'olive',
    'mass',
    'bama'
];

const getDefaultBounds = (affiliate) => {
    affiliate = affiliate.split('_')[1];
    return defaults[affiliate];
}

class SrpMap extends React.Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef(); // access element attributes within the component
        this.mapRef = React.createRef();
        this.noBottomMobileAd = noBottomMobileAdAffs.includes(this.props.affiliate.split('_')[1]);
        this.state = {
            viewport: {
                height: 600,
                width: 400,
                latitude: 0,
                longitude: 0,
                zoom: 6
            },
            popupInfo: null,
            initialLoad: true,
            windowWidth: window.innerWidth,
            defaultBounds: getDefaultBounds(props.affiliate)
        };
    }


    _renderListingMarker = (listingList, index) => {
        const listing = listingList[0];
        const {list_type, price, rent_max, rent_min, longitude, latitude, premier_listing, showcase_home} = listing._source;
        if (longitude) {
            let text = list_type.toUpperCase() === 'RESALE'
                            ? `${listingList.length} units`
                            : `${listingList.length} results`

            if (listingList.length === 1) {
                text = price
                        ? "$" + shortDollarFormat(price, 1)
                        : rent_min
                            ? "$" + (rent_max !== rent_min
                                ? shortDollarFormat(rent_min) + '+'
                                : shortDollarFormat(rent_min))
                            : 'Contact'
            }
            let pinId = latitude + longitude;
            let isHovered = pinId === this.props.hoveredPin;
            let pinSize = !isHovered
                ? '55'
                : '60';
            return (
                <Marker
                    key={`marker-${index}`}
                    longitude={Number(longitude)}
                    latitude={Number(latitude)}
                    className={isHovered ? "hovered" : ""}
                >
                    <ListingPin
                        id={pinId}
                        size={pinSize}
                        text={text}
                        onClick={() => {
                            // TRACK: map_pin_click
                            trackClick('map_pin_click',`map_pin_click: ${listing._source.ad_id}`);
                            this.setState({popupInfo: listingList.map(listing => listing._source)})
                        }}
                        isHovered={isHovered}
                        premier={premier_listing}
                        showcase={showcase_home}
                    />
                </Marker>
            );
        } else {
            return false;
        }
    }

    _renderPopup() {
        const {hoveredPopup} = this.props;
        const {popupInfo} = this.state;
        return popupInfo && (
            <Popup tipSize={5}
                anchor="top"
                longitude={Number(popupInfo[0].longitude)}
                latitude={Number(popupInfo[0].latitude)}
                closeOnClick={false}
                onClose={() => this.setState({popupInfo: null})} >
                <ListingInfo
                    properties={popupInfo}
                    hoveredPopup={hoveredPopup}
                    clickFunction={this.props.openModalClick}
                />
            </Popup>
        );
    }


    _setMapBB(prevProps) {
        const {mapSearch, items, setMapBounds} = this.props;
        const {defaultBounds, initialLoad, viewport} = this.state;
        const lngs = items.map((item) => item._source.longitude).filter((v) => v )
        const lats = items.map((item) => item._source.latitude).filter((v) => v )
        const prevPropsLngs = prevProps.items.map((item) => item._source.longitude).filter((v) => v );
        const minLng = (lngs.length > 0) ? Math.min(...lngs) : defaultBounds['lng'][0];
        const maxLng = (lngs.length > 0) ? Math.max(...lngs) : defaultBounds['lng'][1];
        const minLat = (lats.length > 0) ? Math.min(...lats) : defaultBounds['lat'][0];
        const maxLat = (lats.length > 0) ? Math.max(...lats) : defaultBounds['lat'][1];

        // recalculate map boundaries if the data has changed. We compare the set of all listing longitudes to
        // see if they changed when the Map component has been updated.
        if (prevPropsLngs.join(',') !== lngs.join(',') || initialLoad) {
            let WMViewport = null;

            if (minLng !== maxLng && !!viewport) {
                try {
                    WMViewport  = new WebMercatorViewport(viewport).fitBounds(
                        [[minLng, minLat], [maxLng, maxLat]],
                        {padding: 70}
                    );
                } catch(err) {console.log('viewport ' + err)}
                const viewStateMapBounds = {
                    swLat: minLat,
                    swLng: minLng,
                    neLat: maxLat,
                    neLng: maxLng
                }
                setMapBounds(viewStateMapBounds);
            }

            const viewportLongitude = (WMViewport) ? WMViewport.longitude : minLng;
            const viewportLatitude = (WMViewport) ? WMViewport.latitude : minLat;
            const viewportZoom = (WMViewport) ? WMViewport.zoom : 11;

            if (!mapSearch) {
                this.setState(
                    {viewport:{
                        height: 600,
                        width: 400,
                        longitude: viewportLongitude,
                        latitude: viewportLatitude,
                        zoom: viewportZoom}})
            }
            if (initialLoad) this.setState({initialLoad: false})
        }
    }


    componentDidUpdate(prevProps, prevState) {
        this._setMapBB(prevProps)
        var popupInner = window.document.querySelector('.popup-inner')
        if (popupInner) {
            popupInner.onwheel = (event) =>  {
                event.stopPropagation();
                console.log("wheeling");
            };
        }
    }


    _mapUpdate(currentViewState) {
        const {mapSearch, getResults, setMapBounds} = this.props;
        const loader = window.document.querySelector('.loader');
        this.setState(currentViewState);
        if (this.mapRef && this.mapRef.getMap) {
            const mapBounds = this.mapRef.getMap().getBounds();
            const viewStateMapBounds = {
                swLat: mapBounds._sw.lat,
                swLng: mapBounds._sw.lng,
                neLat: mapBounds._ne.lat,
                neLng: mapBounds._ne.lng
            }
            setMapBounds(viewStateMapBounds);
            if (currentViewState && this.mapRef && mapSearch) {
                clearTimeout(this.queryTimeout);
                this.queryTimeout = setTimeout(
                    () => {
                        loader.classList.add('active');
                        // TRACK: drags the map (when SFM is set)
                        trackClick('search_form_click', `drags-the-map: true`);
                        getResults(
                            ()=>loader.classList.remove('active'),
                            viewStateMapBounds)
                    }, 200);
            }
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateWindowDimensions.bind(this));
    }

    updateWindowDimensions = () => {
       this.setState({windowWidth: window.innerWidth});
    }

    render() {
        const offset = (window.innerWidth > 720)
            ? 90
            : (this.noBottomMobileAd ? 1 : 50);
        const height = this.myRef.current
            ? this.myRef.current.offsetHeight - offset
            : '600px';
        return (
            <div className={`srp-map ${(this.props.defaultMapView) ? '' : 'hidden'}`} ref={this.myRef}>
                <ReactMapGL
                    {...this.state.viewport}
                    width = '100%'
                    height={height}
                    mapStyle="mapbox://styles/mapbox/streets-v11"
                    maxPitch={0}
                    onViewportChange={(viewport) => this._mapUpdate({viewport})}
                    ref={map => {this.mapRef = map}}
                    mapboxApiAccessToken = {mapboxToken}
                    className='innermap'>

                    {groupBy(this.props.items, item => `${item._source.latitude},${item._source.longitude}`)
                        .map(this._renderListingMarker)
                    }

                    {this._renderPopup()}

                    <div className="nav srp-map-nav" style={navStyle}>
                        <NavigationControl onViewportChange={(viewport) => this.setState({viewport})} />
                    </div>
                </ReactMapGL>
                <div className="Window_Below" id="Window_Bottom"></div>
            </div>
        )
    }
}

function groupBy(arr, groupingFn) {
    // Group an array into an array of sub-arrays, whose members map to the same value
    // according to a grouping function.
    // Example: group properties according to same lat/long
    return arr.reduce((grouperArray, item) => {
        // does the new item have the same lat-long as an existing group?
        const existingGrouperIndex = grouperArray.map(subgroup => groupingFn(subgroup[0])).indexOf(groupingFn(item));
        // if so, set grouper to that group; if not, create a new array and add the new array to the grouperArray
        const grouper = (existingGrouperIndex !== -1)
            ? grouperArray[existingGrouperIndex]
            : (() => {var newGroup = []; grouperArray.push(newGroup); return newGroup;})();
        // append the new item to the grouper, whether it's a new array or one that already existed.
        grouper.push(item);
        return grouperArray;
        }, [])
}

export default SrpMap;
